import { useMemo } from 'react';
var KEYS = {
  ENTER: 13,
  TAB: 9
};
export default function useOnTabAndOnEnter(_ref) {
  var {
    onEnter,
    onKeyDown,
    onTab
  } = _ref;
  var onKeyDownEventHandler = useMemo(() => e => {
    switch (e.keyCode) {
      case KEYS.TAB:
        {
          var _direction = e.shiftKey ? -1 : 1;
          return onTab === null || onTab === void 0 ? void 0 : onTab(_direction, e);
        }
      case KEYS.ENTER:
        {
          return onEnter === null || onEnter === void 0 ? void 0 : onEnter(e);
        }
    }
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
  }, [onEnter, onKeyDown, onTab]);
  return onKeyDownEventHandler;
}
//# sourceMappingURL=index.js.map